import React, { useEffect, useState } from 'react';
import pebblogo from "../src/images/banner-logo.jpg";
import bgimage from "../src/images/bg-image.jpg"
import { FaFacebookF } from "react-icons/fa";
import { RiTwitterXLine } from "react-icons/ri";
import { FaLinkedinIn } from "react-icons/fa6";
import { FaGoogle } from "react-icons/fa";
import newsletter from "../src/images/newsletter.png"
import { Button } from "@mui/material";
import bgreen from "../src/images/leaves.png"
import { MdOutlineKeyboardArrowDown } from "react-icons/md";
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import CardActionArea from '@mui/material/CardActionArea';
import ceo from "../src/images/ceo.jpeg"
import nasir from "../src/images/admin2.jpeg"
import ijaz from "../src/images/admin.jpeg"
import waqas from "../src/images/electric.jpeg"
import developers from "../src/images/developers.gif"
import { GiHamburgerMenu } from "react-icons/gi";
import { MdKeyboardArrowLeft } from "react-icons/md";
import { GiStonePile } from "react-icons/gi";
import { MdKeyboardArrowRight } from "react-icons/md";







const Home = () => {

 const [active , setactive] = useState(0)
 const [activeceo , setactiveceo] = useState(false);
 const [activedevelop , setactivedevelop] = useState(false);
 const [sidebar , setsidebar] = useState(false);
 const [submenu , setsubmenu] = useState(false);

 const handleActive = (index) => {

setactive(index)
setsidebar(false);
 }

 const handlescroll = () => {

  window.scrollTo({
    top: '700',
    behavior: "smooth"
  });
 }

 const scrolling = () => {

  if (window.scrollY >= 500) {

    setactiveceo(true);

  }else {

    setactiveceo(false)
  }

 }

  const scrolling2 = () => {

  if (window.scrollY >= 800) {

    setactivedevelop(true);

  }else {

    setactivedevelop(false)
  }

 }

 window.addEventListener('scroll' , scrolling)
 window.addEventListener('scroll' , scrolling2)

 useEffect(() => {

  
}, []);

  return (
    <>
    <div>
      <div className='container-fluid'>   

       
           <div className='logoresponsive'>
              <img src={pebblogo}  alt="logo" />
            </div>

            <div className='navbarme' onClick={() => setsidebar(!sidebar)}>
              <GiHamburgerMenu />
            </div>

            <div className='headertext'>
              <span className='upper'>Pebbles Private Limited</span>
              <span className='down'>Developers & Project Managers</span>              
            </div>

            <div className={`sidebarme ${sidebar? 'active' : ''}`}>
            <div className='logowrapper'>
              <img src={pebblogo}  alt="logo" />
              <div className='svgcontainer'onClick={() => setsidebar(!sidebar)}>
                <MdKeyboardArrowLeft/>
              </div>
            </div>
            <div className='icons'>
              <ul className='menu'>
               <li>                 
                <Button>
                  <GiStonePile/>
                  <span>Pebbles</span>
                  <MdKeyboardArrowRight className='arrowsvg' onClick={() => setsubmenu(!submenu)}/>
                  </Button>               
                </li>
               <ul className={`submenu ${submenu? 'active' : ''}`}>
                <li onClick={() => handleActive(0)}> <Button>CEO's Messege</Button> </li>
                <li onClick={() => handleActive(1)}> <Button>Our Vision</Button> </li>
                <li onClick={() => handleActive(2)}> <Button>Profile</Button> </li>
                </ul>   

                <li>                 
                <Button>
                  <GiStonePile/>
                  <span>Projects</span>
                  <MdKeyboardArrowRight className='arrowsvg'/>
                  </Button>               
                </li>
                          
              </ul>
            </div>
            </div>
    
      
<div className='imagewrapper'>
<img src={bgreen} alt="" /> 
 <div className='row content'>        
          <div className='col-sm-3 col-md-3 col-lg-3 '>
          <h4 className='text-white ml-5 mt-2'>Pebbles Private Limited</h4>
          <h6 className='text-white ml-5'>Developers & Project Managers</h6>
          </div>

           <div className='col-sm-8 col-md-8 col-lg-8 d-flex justify-content-center align-items-center bttns '>
               <div className='position-relative drop'>
                <div className='d-flex justify-content-center align-items-center cursor-pointer'>
                   <h5>Pebbles</h5>
                 <MdOutlineKeyboardArrowDown/>
                </div>
                <ul className='dropdown'>
                  <Button onClick={() => handleActive(0)}><li>CEO's Message</li></Button>
                  <Button onClick={() => handleActive(1)}><li>Our Vision</li></Button>
                  <Button onClick={() => handleActive(2)}><li>Profile</li></Button>
                  {/* <Button onClick={handlescroll}><li>Pebbles Team</li></Button> */}
                </ul>
               </div>

                {/* <div className='position-relative drop'>
                  <div className='d-flex justify-content-center align-items-center cursor-pointer'>
                   <h5>Sevices</h5>
                 <MdOutlineKeyboardArrowDown/>
                </div>
                <ul className='dropdown'>
                  <Button><li>As Developers</li></Button>
                  <Button><li>As Project Managers</li></Button>
                  <Button><li>As Supply Chain Solution Providers</li></Button>
                </ul>
               </div> */}

                <div className='position-relative drop'>
                  <div className='d-flex justify-content-center align-items-center cursor-pointer'>
                   <h5>Corporate</h5>
                 <MdOutlineKeyboardArrowDown/>
                </div>
                <ul className='dropdown2'>
                  <Button><li>Board of Directors</li></Button>
                   <li><Button>  <a className='linkref' href="https://dawoodinvestments.com/" target="_blank" rel="noopener noreferrer">
          Dawood Group
        </a></Button></li>  
                  
                </ul>
               </div>           

               
                <div className='position-relative drop'>
                  <div className='d-flex justify-content-center align-items-center cursor-pointer'>
                   <h5><a className='linkref text-white' href="https://www.ecommunity.pk/" target="_blank" rel="noopener noreferrer">
          Projects
        </a></h5>                
                </div>
               
               </div>      

                {/* <div className='position-relative drop'>
                  <div className='d-flex justify-content-center align-items-center cursor-pointer'>
                   <h5>News & Events</h5>                
                </div>
               
               </div>      */}

{/*                
                <div className='position-relative drop'>
                  <div className='d-flex justify-content-center align-items-center cursor-pointer'>
                   <h5>Offices</h5>                
                </div>              
               
               </div>      */}

                <div className='position-relative drop'>
                  <div className='d-flex justify-content-center align-items-center cursor-pointer'>
                   <h5 onClick={handlescroll}k>Contact Us</h5>                
                </div>              
               
               </div>    

               
              
          </div>
          
          <div className='col-sm-1 col-md-1 col-lg-1 '>
         <div className='logo'>
              <img src={pebblogo}  alt="logo" />
            </div>
          </div>
         
          </div>
</div>
          
       

        <div className='backside mt-4' style={{backgroundImage:`url("/bg-image.jpg")`, backgroundRepeat: "no-repeat" ,
          backgroundSize: "cover" , backgroundPosition: "center"
        }}>
        <div className={`overlaynew ${active===0 ? 'active1' : active===1 ? 'active2' : active===2 ? 'active3' : ''}`}>
        <div className='d-flex align-items-center'>
          <div className='ceomessage'>
        <h5 className='text-white'>CEO's Message</h5>
                  <p className='text-white'>It is increasingly evident that our present day structures are being challenged by a host of factors,
                    particularly in relation to the design intent, space optimization, effective energy usage, water wastage,
                    pollution, landscape, parking spaces, ventilation, natural light, firefighting, garbage disposal and above all
                    safety and security of the occupants.<br/><br/>

                    The harshness of weather was a painful realization in my younger days. After decades,
                    I feel the difference is much deeper in a state of crisis. It is only the carefully planned
                    Ideas and Designs that can help save further deterioration of Environment and our living styles. 
                    Conservation of resources and sustainability is the call of the day and intelligent use of resources 
                    needs to be realized as the real pivotal focus of Construction. Conservation of resources and their 
                    smart sensible use is a beauty that’s more realistic than a natural surrounding.<br/><br/>

                    I believe it is life’s big simple lessons; we must focus to be fine human beings. Therefore at <br/>
                    <span className="fw-bold">Pebbles (Pvt) Ltd</span> know that for every structure built, 
                    someone has to pay a price and that we have to draw a line to take it as if personal.</p>

          </div>
          <div className={`ourprofile ${active===1 ? 'active2' : ''}`}>
        <h5 className='text-white'>Our Vision</h5>
                  <p className='text-white'>To penetrate up-and-coming real estate market by encouraging sustainable business practices,<br/> 
                    efficient building concepts and to demonstrate a strong awareness about preservation,<br/> 
                    recycling of resources and reliable energy sources.</p>

                    <h5 className='text-white'>Our Aim</h5>
                  <p className='text-white'>To give an aesthetic and efficient touch to contemporary building concepts by 
                    emphasizing<br/> on living community as it is true that we<br/> owe our existence to Nature and know that we get 
                    what we give to the Environment around us.</p>

                    <h5 className='text-white'>Our Innovation</h5>
                  <p className='text-white'>All our projects will aim to earn LEED certification, meaning we measure how<br/> well a building or community performs 
                    across all the metrics that matter most: energy savings,<br/> water efficiency, CO2 emissions reduction, 
                    improved indoor environmental quality, and stewardship<br/> of resources<br/> and sensitivity to their impacts. 
                    LEED is flexible enough to apply to all building types – commercial as <br/>well as residential. It works 
                    throughout the building lifecycle – design and construction, operations<br/> and maintenance, tenant fit out, and significant retrofit.</p>
            

          </div>

            <div className={`profile ${active===2 ? 'active3' : ''}`}>
        <h5 className='text-white'>Profile</h5>
                  <p className='text-white'>The Dawood Group has an outstanding reputation, earning the highest ratings of excellence
                     in industries like fertilizer and textiles to business and finance. The Group has recently added to its family with
                      the introduction of a family owned business, Pebbles (Pvt.) Ltd, a Real Estate venture established to create Quality
                       based Sustainable building Project Management and Development. The Dawood Group entered the Real Estate market in 1964, 
                       with the construction of Dawood Centre, one of the most prestigious business addresses in Pakistan to date. Pebbles is 
                       the renaissance of this glorious tradition, initiated to be established as a trusted name and is technically 
                       equipped to be the only Sustainable Development company throughout Pakistan in the Construction industry.

It is the only member company of USGBC (United States Green Building Council) in Pakistan and is a registered member of ABAD (Association of
 Builders and Developers). The integrated Project Delivery System and provision of Real Estate in Supply Chain Solutions are yet another aspect
  of company’s efficiency and sustainable practices. We at Pebbles understand that the modern World is to be built around conservation of energy
   and resources as it is a matter of survival for the World to save what it can and recycle whatever possible. Our Corporate and
    Retail investors will enjoy the right benefits of our Quality Concepts and Designs to be the real asset to authentic Savings 
    and Sustainability in Construction.</p>

                  
          </div>
        </div>
        </div>
        </div>

           <div className='row footer'>
          <div className='col-sm-12 col-md-12 col-lg-12 border part1'>
        <div className='row bodycontainer'>
           <div className='col-sm-3 col-md-3 col-lg-3 d-flex justify-content-center align-items-center flex-column'>              
          <h5 className='text-white'>Site Office / Project Location</h5>
          <p className='text-white'>8Km, Main Sheikhupura-Lahore Road, Sheikhupura Pakistan</p>         
           </div>
             <div className='col-sm-3 col-md-3 col-lg-3 d-flex justify-content-center align-items-center flex-column'>
             <h5 className='text-white'>Phone Inquiries</h5>
          <p className='text-white'>Cell: +92 321 4000392<br/>
Phone: +92 056 3543490</p>
           </div>
             <div className='col-sm-3 col-md-3 col-lg-3 d-flex justify-content-center align-items-center flex-column'>
              <h5 className='text-white'>Online Query / Feedback</h5>
          <p className='text-white'>khalid.sultan@pebbles.com.pk</p>
           </div>
             <div className='col-sm-3 col-md-3 col-lg-3 d-flex justify-content-center align-items-center flex-column'>
            <h5 className='text-white'>Subscribe Newsletter</h5>
            <img src={newsletter} style={{width: "200px" , height: "200px", objectFit: "contain"}} alt="" />
           </div>         
        </div>
          </div>
        </div>


        {/* <div className='team'>
          <div className={`onlyceonew ${activeceo ? 'active' : ''}`}>
          <img src={ceo} alt="" />
          <div className='content'>
            <h4>Mr.Farhan Manzoor</h4>
          <h6>Company CEO</h6>
          </div>
          </div>
        
           <div className={`others ${activeceo? 'active' : ''}`}>
            <div className={'mycard'}>
          <img src={ijaz} alt="" />
          <div className='content'>
            <h4>Col Ijaz Ahmad Bhutta </h4>
          <h6>Admin Manager</h6>
          </div>
          </div>

          <div className={'mycard'}>
          <img src={nasir} alt="" />
          <div className='content'>
            <h4>Mr.Naseem Nasir </h4>
          <h6>Assistant Admin Manager</h6>
          </div>
          </div>

          <div className={'mycard'}>
          <img src={waqas} alt="" />
          <div className='content'>
            <h4>Mr.Waqas Riaz </h4>
          <h6>Electrical Engineer</h6>
          </div>
          </div>

      
           </div>

        </div> */}

     

        {/* <div className={`servicesnew ${activedevelop? 'active' : ''}`}>          
          <div className='part1' style={{backgroundImage: `url("/developers.gif")`, backgroundRepeat: "no-repeat" ,
            backgroundPosition: "center" , backgroundSize: "cover" }}>
        
          <div className='overlaydevelopers'>
            <h3>AS Developers</h3>
            <p>We have the capacity of developing a land site into a modern day marvel by 
              completing time lines, capital injection and involving the most modern construction techniques. 
              As developers we shall soon be exposing a housing scheme on a company held land asset in the historic city of Sheikhupura. 
              Through our developments we will alter land from natural, biologically diverse habitats to hard-scape that will be 
              impervious and devoid of biodiversity.</p>
          </div>
          </div>

           <div className='part1' style={{backgroundImage: `url("/developers.gif")`, backgroundRepeat: "no-repeat" ,
            backgroundPosition: "center" , backgroundSize: "cover" }}>
        
          <div className='overlaydevelopers2'>
            <h3>As Project Managers</h3>
            <p>We are deeply inspired by the Integrated Project Delivery System formulated by American Institute of Architects (AIA) 
              and we also fully understand that Green building practices can substantially reduce or eliminate negative environmental 
              impacts through high performance design, construction, and operations practices. With our added benefits, green operations 
              and management reduce operating cost, enhance building marketability and increase dwellers productivity. We have the honor
               of having been appointed as Project Managers for the projects involving mixed use high rise buildings in Lahore and Karachi.</p>
          </div>
          </div>

           <div className='part1' style={{backgroundImage: `url("/developers.gif")`, backgroundRepeat: "no-repeat" ,
            backgroundPosition: "center" , backgroundSize: "cover" }}>
        
          <div className='overlaydevelopers3'>
            <h3>As Supply Chain Solution Providers</h3>
            <p>Our building practices also incorporate the complete development, from land procurement to handing over the keys of PBWH 
              (Purpose Built Warehouse) TCWH (Temperature Control Warehouse) and CA Storage (Controlled Atmosphere Storage) to warehouse
               managers, logistics companies and the manufacturers on rental basis, which is the need of the hour in Pakistan. We will 
               develop PBWHs, TCWHs and CA Storages all along the National trade corridor and plan to complete our two PBWHs at Lahore 
               and Islamabad by the first half of year 2010.</p>
          </div>
          </div>
        </div> */}

        
      
            

{/* 
         <div className='d-flex justify-content-center align-items-center'>
        <div className='row mt-4 pebbles'>
          <div className='col-sm-12 col-md-12 col-lg-12'>
          
          </div>
        </div>
         </div> */}
      </div>
    </div>
    </>
  )
}

export default Home
